<template>
  <ubi-page-container>
    <template v-slot:page-actions>
      <social-posts-list-header v-if="userRS.length > 0 && sitimmoUser.packSocialManagement"></social-posts-list-header>
    </template>

    <confirm-delete-posts
      :modal-visible="modalVisible"
      :annonce="currentPost"
      v-on:close-modal-confirm-delete="closeModalDelete($event)"
      v-on:confirm-delete-posts="desactiverSelection($event)"></confirm-delete-posts>
    <confirm-delete-posts-b-v
      :modal-visible="modalVisible"
      :annonce="currentPost"
      v-on:close-modal-confirm-delete="closeModalDelete($event)"
      v-on:confirm-delete-posts="desactiverSelection($event)"></confirm-delete-posts-b-v>
    <confirm-delete-editorial-posts></confirm-delete-editorial-posts>
    <el-form @submit.prevent.native="search()" label-position="top" v-if="userRS.length > 0">
      <social-posts-list-search
          v-on:resetfilter="doFilter('resetFromSearch')"
          v-on:do-filter="doFilter($event)"
          :active-tab="activeTab"></social-posts-list-search>
      <social-posts-list-table
          :posts="socialNetworkPosts"
          :selected-posts-annonces="selectedPostsAnnonces"
          :selected-posts-b-v="selectedPostsBV"
          v-on:changetab="changeActiveTab($event)"
          v-on:show-modale-delete="showModalDelete($event)">
      </social-posts-list-table>
    </el-form>
    <ubi-panel v-else>
      <el-row class="text-center">
        <el-col :lg="24" v-html="$t('socialPosts.list.noSubscription')">
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="24">&nbsp;</el-col>
      </el-row>
      <el-row class="text-center">
        <el-col :lg="24">
          <a href="https://www.ubiflow.net/annonces-automobiles-google-facebook-instagram" v-if="universe === 'VO'" target="_blank">
            <el-button type="primary">{{$t('layouts.contactUs')}}</el-button>
          </a>
          <a href="https://www.ubiflow.net/annonces-immobilieres-google-facebook-instagram" v-else target="_blank">
            <el-button type="primary">{{$t('layouts.contactUs')}}</el-button>
          </a>
        </el-col>
      </el-row>
    </ubi-panel>
  </ubi-page-container>

</template>

<script>

import SocialPostsListHeader from './Blocks/SocialPostsListHeader'
import SocialPostsListSearch from './Blocks/SocialPostsListSearch'
import SocialPostsListTable from './Blocks/SocialPostsListTable'
import { mapMutations, mapState } from 'vuex'
import { fetchSocialPosts } from '../../services/posts'
import UbiPanel from '@/components/Panel'
import ConfirmDeletePosts from '@/pages/socialNetworks/Blocks/ConfirmDeletePosts'
import ConfirmDeletePostsBV from '@/pages/socialNetworks/Blocks/ConfirmDeletePostsBV'
import ConfirmDeleteEditorialPosts from '@/pages/socialNetworks/Blocks/ConfirmDeleteEditorialPosts'
import { diffusionAnnonceActivate, planificationsAnnonceActivate } from '@/services/portals'
import store from '@/store'

export default {
  name: 'SocialPostsList',
  components: {
    ConfirmDeletePostsBV,
    ConfirmDeletePosts,
    ConfirmDeleteEditorialPosts,
    UbiPanel,
    SocialPostsListHeader,
    SocialPostsListSearch,
    SocialPostsListTable
  },
  data () {
    return {
      modalVisible: false,
      currentPost: null,
      activeTab: 'Annonces',
      selectedPostsAnnonces: 0,
      selectedPostsBV: 0,
      socialNetworkPosts: {
        list: [],
        total: 0
      }
    }
  },
  computed: {
    ...mapState('socialNetworkPosts', ['filter', 'results']),
    userRS () {
      return this.$store.getters.getUser.socialNetworkIds
    },
    universe () {
      return this.$store.getters.getSitimmoUser.univers
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    }
  },
  mounted () {
    this.$store.commit('socialPostsCreationPostEditorial/setRedirection', false)
    this.$store.dispatch('promptLibraries/loadPrompts')
    this.$store.dispatch('promptLibraries/loadTonsIa')
    this.$store.dispatch('promptLibraries/loadListDataInitialByJob')
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'new-social-post' || to.name === 'edit-post-editorial' || to.name === 'manage-posts') {
      next()
    } else {
      this.$store.commit('socialNetworkPosts/setCurrentTab', 'Annonces')
      next()
    }
  },
  methods: {
    closeModalDelete (event) {
      this.modalVisible = false
    },
    search () {
      if (this.activeTab === 'Annonces') {
        this.$store.dispatch('socialPostsTableAnnonces/loadSocialPostsAnnonces')
      } else if (this.activeTab === 'BienVendus') {
        this.$store.dispatch('socialPostsTableBiensVendus/loadSocialPostsBiensVendus')
      } else {
        this.$store.dispatch('socialPostsTableEditoriaux/loadSocialPostsEditoriaux')
      }
    },
    changeActiveTab (event) {
      this.activeTab = event
    },
    showModalDelete (event) {
      this.currentPost = event
      this.modalVisible = true
    },
    async desactiverSelection () {
      this.loading = true
      this.selectedPostsAnnonces = 1
      this.selectedPostsBV = 1
      let annonces = []
      const currentTab = this.$store.state.socialNetworkPosts.currentTab
      if (currentTab === 'Annonces') {
        this.$store.commit('socialPostsTableAnnonces/setLoadingStatus', true)
        annonces = this.$store.state.socialPostsTableAnnonces.postToDelete
      } else if (currentTab === 'BienVendus') {
        annonces = this.$store.state.socialPostsTableBiensVendus.postToDelete
        this.$store.commit('socialPostsTableBiensVendus/setLoadingStatus', true)
      }
      for (const annonce of annonces) {
        const tabJson = await this.generateTabJson(annonce)
        const arrayPlanifications = await this.generateArrayPlanifications(annonce)

        const response = await diffusionAnnonceActivate(tabJson)
        const self = this
        arrayPlanifications.forEach(function (planif) {
          this.$store.dispatch('calendarSocialPosts/deleteScheduled', [planif])
        }, self)
      }
      if (currentTab === 'Annonces') {
        this.$store.commit('socialPostsTableAnnonces/setModalDelete', false)
        this.$store.dispatch('socialPostsTableAnnonces/loadSocialPostsAnnonces')
        this.$store.commit('socialPostsTableAnnonces/setLoadingStatus', false)
      } else if (currentTab === 'BienVendus') {
        this.$store.commit('socialPostsTableBiensVendus/setModalDelete', false)
        this.$store.dispatch('socialPostsTableBiensVendus/loadSocialPostsBiensVendus')
        this.$store.commit('socialPostsTableBiensVendus/setLoadingStatus', false)
      } else {
        this.$store.commit('socialPostsTableBiensVendus/setModalDelete', false)
        this.$store.dispatch('socialPostsTableBiensVendus/loadSocialPostsBiensVendus')
        this.$store.commit('socialPostsTableBiensVendus/setLoadingStatus', false)
      }
      this.selectedPostsAnnonces = 0
      this.selectedPostsBV = 0
    },
    async generateTabJson (annonce) {
      const tabJson = {}
      tabJson.diffusions = []
      const self = this
      if (annonce.diffusions && annonce.diffusions.length > 0) {
        annonce.diffusions.forEach(function (diffusion) {
          const codeName = this.searchCodename(diffusion.diffuseur)
          const tempTab = {}
          tempTab.diffuseur = codeName
          tempTab.annonce = annonce.id
          tempTab.activate = 0
          tabJson.diffusions.push(tempTab)
        }, self)
      }
      return tabJson
    },
    async generateArrayPlanifications (annonce) {
      const tabPlanif = []
      const self = this
      if (annonce.planifications && annonce.planifications.length > 0) {
        annonce.planifications.forEach(function (planification) {
          const tempTab = {}
          tempTab.id = planification.id
          tempTab.annonces = [annonce.id]
          tabPlanif.push(tempTab)
        }, self)
      }
      return tabPlanif
    },
    searchCodename (diffuseurId) {
      let codeName = ''
      store.getters.getUser.socialNetworkCodenames.forEach(function (diffusion) {
        if (diffusion[0] === diffuseurId) {
          codeName = diffusion[1]
        }
      })
      return codeName
    },
    doFilter (type) {
      switch (type) {
        case 'resetFromSearch':
          this.filter.search = ''
          this.setFilter(this.filter)
          break
      }
    }
  }
}

</script>

<style scoped>

</style>
